"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var StickyCover = /*#__PURE__*/function () {
  function StickyCover(container, wrapperClass, page, isTop) {
    var _this = this;

    _classCallCheck(this, StickyCover);

    this.DESCRIPTION_HEIGHT_RATIO = 0.5;
    this.container = $(container);
    this.page = page;
    this.isTop = isTop;
    this.window = $(window);
    this.wrapperClass = wrapperClass;
    this.description = $('div.description', this.container);
    this.image = $('div.toggle-image', this.container);
    this.buttons = $('div.toggle-buttons', this.container);
    this.descriptionInitialHeight = 0;
    this.imageInitialHeight = 0;
    this.imageInitialWidth = 0;
    this.buttonsInitialHeight = 0;
    this.initialContainerHeight = 0;
    this.containerHeight = 0;
    this.initialWrapperHeight = 0;
    this.initialTriggerPoint = 0;
    this.triggerPointDifference = 0;
    this.windowScrollTop = this.window.scrollTop();
    this.resizeTimeout;
    this.helperContainer;
    this.sticky;
    this.resizeHelperEnabled = this.container.data('resizeHelper') === false ? false : true;
    this.windowResize = this.window.width();
    this.scrollPositionChange = this.container.data('positionChange');
    this.window.scroll(function () {
      _this.windowScrollTop = _this.window.scrollTop();
    });
    this.windowScrollTop = this.window.scrollTop();

    if (this.resizeHelperEnabled) {
      this.window.resize(function () {
        if (_this.resizeTimeout) {
          clearTimeout(_this.resizeTimeout);
        }

        _this.resizeTimeout = setTimeout(function () {
          if (_this.window.width() != _this.windowResize) {
            _this.setInitialSize();

            _this.initPosition();
          }
        }, 300);
      });
    }

    this.setInitialSize();
    this.initPosition();
  }

  _createClass(StickyCover, [{
    key: "getCollapsedHeight",
    value: function getCollapsedHeight() {
      return $('.page-title').outerHeight();
    }
  }, {
    key: "getCoverHelperHeight",
    value: function getCoverHelperHeight() {
      if (!this.helperContainer) {
        this.helperContainer = $('<div id="sticky-cover-helper-container"></div>');
        $('body').prepend(this.helperContainer);
        this.helperContainer.append(this.container.clone());
      }

      this.descriptionInitialHeight = this.helperContainer.find('.description').height();
      this.imageInitialHeight = this.helperContainer.find('.toggle-image').height();
      this.imageInitialWidth = this.helperContainer.find('.toggle-image').width();
      this.buttonsInitialHeight = this.helperContainer.find('.toggle-buttons').height();
      var height = this.helperContainer.height();
      return height;
    }
  }, {
    key: "setInitialSize",
    value: function setInitialSize() {
      if (this.resizeHelperEnabled) {
        this.initialContainerHeight = this.getCoverHelperHeight();
      } else {
        this.initialContainerHeight = this.container.outerHeight(true);
      }
    }
  }, {
    key: "showDescription",
    value: function showDescription(state) {
      if (this.description.length != 0) {
        this.description.css({
          height: this.descriptionInitialHeight
        });

        if (state) {
          this.description.css({
            height: this.descriptionInitialHeight
          });
          this.description.removeClass('fadeOut');
        } else {
          var height = Math.min(Math.max(this.descriptionInitialHeight - this.windowScrollTop * this.DESCRIPTION_HEIGHT_RATIO, 0), this.descriptionInitialHeight);
          this.description.css({
            height: height
          });
          this.description.addClass('fadeOut');
        }
      }
    }
  }, {
    key: "showImage",
    value: function showImage(state) {
      if (this.image.length != 0) {
        this.image.css({
          height: this.imageInitialHeight,
          width: this.imageInitialWidth
        });

        if (state) {
          this.image.css({
            height: this.imageInitialHeight,
            width: this.imageInitialWidth
          });
          this.image.addClass('gr-3');
          this.image.removeClass('fadeOut');
        } else {
          var height = Math.min(Math.max(this.imageInitialHeight - this.windowScrollTop * this.DESCRIPTION_HEIGHT_RATIO, 0), this.imageInitialHeight);
          var width = Math.min(Math.max(this.imageInitialWidth - this.windowScrollTop * this.DESCRIPTION_HEIGHT_RATIO, 0), this.imageInitialWidth);
          this.image.css({
            height: height,
            width: width
          });
          this.image.addClass('fadeOut');
          this.image.removeClass('gr-3');
        }
      }
    }
  }, {
    key: "showButtons",
    value: function showButtons(state) {
      if (this.buttons.length != 0) {
        this.buttons.css({
          height: this.buttonsInitialHeight
        });

        if (state) {
          this.buttons.css({
            height: this.buttonsInitialHeight
          });
          this.buttons.removeClass('fadeOut');
        } else {
          var height = Math.min(Math.max(this.buttonsInitialHeight - this.windowScrollTop * this.DESCRIPTION_HEIGHT_RATIO, 0), this.buttonsInitialHeight);
          this.buttons.css({
            height: height
          });
          this.buttons.addClass('fadeOut');
        }
      }
    }
  }, {
    key: "initPosition",
    value: function initPosition() {
      var _this2 = this;

      if (this.sticky) {
        this.sticky.destroy();
      }

      if (this.isTop && this.resizeHelperEnabled === true) {
        this.sticky = new Waypoint.Sticky({
          element: this.container,
          offset: this.page.getHeaderHeight(),
          wrapper: '<div class="' + this.wrapperClass + '" />'
        });
        this.containerHeight = Math.min(Math.max(this.initialContainerHeight - this.windowScrollTop, 0), this.initialContainerHeight);
        var backgroundPosition = this.scrollPositionChange ? Math.min(Math.max(50 - this.windowScrollTop * 0.05, 25), 50) : 50;
        this.initialWrapperHeight = this.initialContainerHeight;
        this.sticky.element.css({
          top: this.page.getHeaderHeight()
        });
        $(this.sticky.wrapper).css({
          height: this.initialWrapperHeight
        });
        setTimeout(function () {
          _this2.sticky.element.css({
            top: _this2.page.getHeaderHeight()
          });

          $(_this2.sticky.wrapper).css({
            height: _this2.initialWrapperHeight
          });
        }, 10);

        if (this.windowScrollTop > 0) {
          this.showDescription(false);
          this.showImage(false);
          this.showButtons(false);
        } else {
          this.showDescription(true);
          this.showImage(true);
          this.showButtons(true);
        }

        this.sticky.element.css({
          top: this.page.getHeaderHeight()
        });
        this.sticky.element.css({
          height: this.containerHeight,
          'backgroundPosition': '50% ' + backgroundPosition + '%'
        });
        this.window.scroll(function () {
          _this2.sticky.waypoint.triggerPoint = 0;
          _this2.containerHeight = Math.min(Math.max(_this2.initialContainerHeight - _this2.windowScrollTop, 0), _this2.initialContainerHeight);

          if (_this2.windowScrollTop >= 0) {
            _this2.sticky.element.css({
              position: 'fixed',
              top: _this2.page.getHeaderHeight()
            });

            $(_this2.sticky.wrapper).css({
              height: _this2.initialWrapperHeight
            });
          } else {
            _this2.sticky.element.css({
              position: 'static',
              top: 'initial'
            });

            $(_this2.sticky.wrapper).css({
              height: _this2.initialWrapperHeight
            });
          }

          var backgroundPosition = _this2.scrollPositionChange ? Math.min(Math.max(50 - _this2.windowScrollTop * 0.05, 25), 50) : 50;

          if (_this2.windowScrollTop > _this2.sticky.waypoint.triggerPoint) {
            _this2.sticky.element.css({
              height: _this2.containerHeight,
              'backgroundPosition': '50% ' + backgroundPosition + '%'
            });

            _this2.showDescription(false);

            _this2.showImage(false);

            _this2.showButtons(false);
          } else {
            _this2.sticky.element.css({
              height: _this2.initialWrapperHeight,
              'backgroundPosition': '50% ' + backgroundPosition + '%'
            });

            _this2.showDescription(true);

            _this2.showImage(true);

            _this2.showButtons(true);
          }
        });
      } else if (this.isTop && this.resizeHelperEnabled === false) {
        this.sticky = new Waypoint.Sticky({
          element: this.container,
          offset: this.page.getHeaderHeight(),
          wrapper: '<div class="' + this.wrapperClass + '" />'
        });
        this.initialWrapperHeight = $(this.sticky.wrapper).outerHeight(true);
        var height = Math.min(Math.max(this.initialContainerHeight - this.windowScrollTop, 0), this.initialContainerHeight);
        this.sticky.element.css({
          top: this.page.getHeaderHeight()
        });
        $(this.sticky.wrapper).css({
          height: this.initialWrapperHeight
        });
        setTimeout(function () {
          _this2.sticky.element.css({
            top: _this2.page.getHeaderHeight()
          });

          $(_this2.sticky.wrapper).css({
            height: _this2.initialWrapperHeight
          });
        }, 10);

        if (this.windowScrollTop > 0) {
          this.showDescription(false);
          this.showImage(false);
          this.showButtons(false);
        } else {
          this.showDescription(true);
          this.showImage(true);
          this.showButtons(true);
        }

        this.sticky.element.css({
          top: this.page.getHeaderHeight()
        });
        this.sticky.element.css({
          height: height
        });
        this.window.scroll(function () {
          _this2.sticky.waypoint.triggerPoint = 0;

          if (_this2.windowScrollTop >= 0) {
            _this2.sticky.element.css({
              position: 'fixed',
              top: _this2.page.getHeaderHeight()
            });
          } else {
            _this2.sticky.element.css({
              position: 'static',
              top: 'initial'
            });

            $(_this2.sticky.wrapper).css({
              height: _this2.initialWrapperHeight
            });
          }

          var height = Math.min(Math.max(_this2.initialContainerHeight - _this2.windowScrollTop, 0), _this2.initialContainerHeight);
          var backgroundPosition = _this2.scrollPositionChange ? Math.min(Math.max(50 - _this2.windowScrollTop * 0.05, 25), 50) : 50;

          if (_this2.windowScrollTop > _this2.sticky.waypoint.triggerPoint) {
            _this2.sticky.element.css({
              height: height,
              'backgroundPosition': '50% ' + backgroundPosition + '%'
            });

            _this2.showDescription(false);

            _this2.showImage(false);

            _this2.showButtons(false);
          } else {
            _this2.sticky.element.css({
              height: height,
              'backgroundPosition': '50% ' + backgroundPosition + '%'
            });

            _this2.showDescription(true);

            _this2.showImage(true);

            _this2.showButtons(true);
          }
        });
      } else {
        this.sticky = new Waypoint.Sticky({
          element: this.container,
          offset: this.page.getHeaderHeight(),
          wrapper: '<div class="' + this.wrapperClass + '" />'
        });
        this.initialWrapperHeight = $(this.sticky.wrapper).outerHeight(true);
        this.initialTriggerPoint = this.sticky.waypoint.triggerPoint;
        this.showDescription(true);
        this.showImage(true);
        this.showButtons(true);
        this.sticky.element.css({
          height: this.initialContainerHeight
        });
        this.window.scroll(function () {
          _this2.triggerPointDifference = _this2.initialTriggerPoint - _this2.sticky.waypoint.triggerPoint;

          if (_this2.triggerPointDifference > 0) {
            _this2.sticky.waypoint.triggerPoint = _this2.initialTriggerPoint;
          }

          var height = Math.min(Math.max(_this2.initialContainerHeight + _this2.initialTriggerPoint - _this2.windowScrollTop, 0), _this2.initialContainerHeight);

          if (_this2.windowScrollTop > _this2.initialTriggerPoint) {
            _this2.sticky.element.css({
              height: height
            });

            _this2.showDescription(false);

            _this2.showImage(false);

            _this2.showButtons(false);
          } else {
            _this2.sticky.element.css({
              height: height
            });

            _this2.showDescription(true);

            _this2.showImage(true);

            _this2.showButtons(true);
          }
        });
      }
    }
  }]);

  return StickyCover;
}();